var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-right",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Carousel / Arrow / Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Carousel-/-Arrow-/-Right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Carousel-Arrow-/-Left",
    transform: "translate(30.000000, 30.000000) rotate(-180.000000) translate(-30.000000, -30.000000) "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FAFAFA",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Right",
    transform: "translate(17.000000, 16.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6933517,23.4208687 L6.01672005,13.8173844 L15.6933517,4.21390003 C16.6660028,3.24860134 16.6660028,1.6892727 15.6933517,0.723974013 C14.7207005,-0.241324671 13.1494949,-0.241324671 12.1768438,0.723974013 L0.729488337,12.084797 C-0.243162779,13.0500957 -0.243162779,14.6094243 0.729488337,15.574723 L12.1768438,26.935546 C13.1494949,27.9008447 14.7207005,27.9008447 15.6933517,26.935546 C16.641063,25.9702473 16.6660028,24.3861674 15.6933517,23.4208687 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7e7ed0c7.svg";
export { ForwardRef as ReactComponent };